import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ICollaboratorResponseAxios } from "../../../../common/interfaces";

import { Button } from "../../../../components/Button";
import { Collaborator } from "../../../../components/Collaborator";
import { HeaderTitle } from "../../../../components/HeaderTitle";
import { useAuth } from "../../../../hooks/useAuth";
import { useNotification } from "../../../../hooks/useNotification";
import { useTranslate } from "../../../../hooks/useTranslate";
import { loadCollaborators } from "../../../../services/collaborators";
import { formatDate } from "../../../../utils/format-date";
import { TypeActionInvivation } from "../../enums";
import { ICollaborator } from "../../interfaces";
import {
  Container,
  Content,
  TotalCollaborator,
  List,
  SectionCollaborators,
  ContentButton,
} from "./styles";

const ListCollaborators = () => {
  const navigate = useNavigate();
  const { propertiesIds, user } = useAuth();
  const { errorNotification } = useNotification();
  const { translate } = useTranslate();

  const [collaboratorsAdmin, setCollaboratorsAdmin] = useState<ICollaborator[]>(
    []
  );
  const [otherCollaborators, setOtherCollaborators] = useState<ICollaborator[]>(
    []
  );

  const navigateUser = (url: string) => {
    navigate(url);
  };

  const boot = useCallback(async () => {
    try {
      const collaborators: ICollaboratorResponseAxios[] = [];
      const page = 1;
      const limit = 1000;
      const farmId = propertiesIds[0];

      const data = await loadCollaborators({
        farmId,
        page,
        limit,
      });

      collaborators.push(...data.data);

      // if (meta.pages > 1) {
      //   for (let index = page + 1; index <= meta.pages; index++) {
      //     const { data } = await loadCollaborators({
      //       farmId,
      //       page: index,
      //       limit,
      //     });
      //     collaborators.push(...data);
      //   }
      // }

      const collaboratorsFormatted = collaborators.map((collaborator) => {
        let isAdmin = false;

        collaborator.permissions.permission.forEach((item) => {
          if (item?.admin) isAdmin = true;
        });
        const status = collaborator.attributes.find(
          (item) => item.type === "status"
        );

        return {
          id: collaborator.id,
          name: collaborator.name,
          office: collaborator.office,
          created_at: formatDate(new Date(collaborator.created_at)),
          admin: isAdmin,
          date_birth: collaborator.date_birth,
          status: Boolean(status?.value),
          isOwner: false,
        };
      });

      const collaboratorsAdmin = collaboratorsFormatted.filter(
        (item) => item.admin
      );
      const collaboratorsNotAdmin = collaboratorsFormatted.filter(
        (item) => !item.admin
      );

      setCollaboratorsAdmin(collaboratorsAdmin);
      setOtherCollaborators(collaboratorsNotAdmin);
    } catch (error) {
      console.log(error);

      errorNotification(translate("collaborator.unknow_error"));
    }
  }, [errorNotification, propertiesIds, translate]);

  const actionButtonCollaborator = (status: boolean, id: string) => {
    if (status) {
      navigateUser(
        `/collaborators/invitation/${TypeActionInvivation.edit}/${id}`
      );
      return;
    }

    navigateUser(
      `/collaborators/invitation/${TypeActionInvivation.resend}/${id}`
    );
  };

  const ready = useRef(false);

  useEffect(() => {
    if (!ready.current) {
      ready.current = true;
      boot();
    }
  }, [boot]);

  return (
    <Container>
      <HeaderTitle title={translate("collaborator.title_list")} />
      <Content>
        <TotalCollaborator>
          <p>{translate("collaborator.total")}</p>
          <span>{collaboratorsAdmin.length + otherCollaborators.length}</span>
        </TotalCollaborator>
        <List>
          <SectionCollaborators>
            <h3>{translate("collaborator.title_section_admin")}</h3>
            <Collaborator
              office={translate("collaborator.office_owner")}
              name={user.name}
              isOwner
            />
            {collaboratorsAdmin.map((collaborator) => (
              <Collaborator
                key={collaborator.id}
                {...collaborator}
                cb={() => {
                  actionButtonCollaborator(
                    collaborator.status!,
                    collaborator.id
                  );
                }}
              />
            ))}
          </SectionCollaborators>
          <SectionCollaborators>
            <h3>{translate("collaborator.title_section_guests")}</h3>
            {otherCollaborators.map((collaborator) => (
              <Collaborator
                key={collaborator.id}
                {...collaborator}
                cb={() => {
                  actionButtonCollaborator(
                    collaborator.status!,
                    collaborator.id
                  );
                }}
              />
            ))}
          </SectionCollaborators>
        </List>
        <ContentButton>
          <Button
            label={translate("collaborator.label_button_new")}
            onClick={() => {
              navigateUser("/collaborators/new");
            }}
          />
        </ContentButton>
      </Content>
    </Container>
  );
};

export { ListCollaborators };
